// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"pictureIcon_label_spec__3Fq2Q","picture_icon_block":"pictureIcon_picture_icon_block__2M8q2"};